import { Col, Modal, Row, Form, Select, Radio, Menu } from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { useEffect, useState } from 'react';
import { RolesService } from '../../../api/Roles/api-roles-permisos';
import getStorageUser from "../../../middlewares/GetStorageUser"
const { SubMenu } = Menu;

const rolesService = new RolesService()

type ConfigurarModalProps = {
    openModal: boolean,
    setOpenModal: Function,
    datos: any,
    loadUsers: Function
}
export const ConfigurarModal = ({ openModal, setOpenModal, datos, loadUsers }: ConfigurarModalProps) => {

    const onCancel = () => {
        setOpenModal(false);
        loadUsers()
    }

    const [roles, setRoles] = useState<any>([])
    const [permissions, setPermissions] = useState<any>([])
    const [userPermissions, setUserPermissions] = useState<any>([])
    const [radioValue, setRadioValue] = useState<any>(datos.active)
    const [contadorAdministracion, setContadorAdministracion] = useState<number>(0)
    const [contadorConvocatorias, setContadorConvocatorias] = useState<number>(0)
    const [contadorMaestras, setContadorMaestras] = useState<number>(0)
    const [contadorPostulaciones, setContadorPostulaciones] = useState<number>(0)
    const [contadorJurados, setContadorJurados] = useState<number>(0)
    const [selectRole, setSelectRole] = useState<number>()
    const [enableAccess, setEnableAccess] = useState<boolean>(false)

    const loadRoles = async () => {
        const { roles } = await rolesService.getRoles()
        setRoles(roles)
    }

    const updateRole = async (role: any) => {
        setEnableAccess(true)
        setSelectRole(role)
        await rolesService.updateRole(role, datos.id)
    }

    const handleRadioChange = async (value: any) => {
        setRadioValue(value)
        await rolesService.updateStatus(value, datos.id)
    }

    const loadPermissions = async () => {
        const { permissions } = await rolesService.getPermissions()
        const user = getStorageUser()

        if (user.role_id != 1) {
            const filteredPermissions = permissions.filter((perm: any) => perm.group != 'Panel de administracion')
            setPermissions(filteredPermissions)
        } else {
            setPermissions(permissions)
        }

        const data = await rolesService.getUserPermissions(datos.id)

        let totalPanel = 0;
        let totalConvocatorias = 0;
        let totalMaestras = 0;
        let totalPostulaciones = 0;
        let totalJurado = 0;


        for (let i in data.permissions) {
            switch (data.permissions[i].group) {
                case "Panel de administración":
                    totalPanel = totalPanel + 1;
                    break;
                case "Crear convocatorias":
                    totalConvocatorias = totalConvocatorias + 1
                    break;
                case "Maestras":
                    totalMaestras = totalMaestras + 1
                    break;
                case "Postulaciones":
                    totalPostulaciones = totalPostulaciones + 1
                    break;
                case "Gestión de jurados":
                    totalJurado = totalJurado + 1
                    break;
            }
        }

        setContadorAdministracion(totalPanel)
        setContadorConvocatorias(totalConvocatorias)
        setContadorMaestras(totalMaestras)
        setContadorPostulaciones(totalPostulaciones)
        setContadorJurados(totalJurado)


        setUserPermissions(data.permissions)
    }

    const handlePermissionCheck = async (value: any, group: any) => {
        if (!userPermissions.find((permission: any) => permission.id === value.id)) {
            await rolesService.assignPermissions([value.id], datos.id)
            setUserPermissions([...userPermissions, value])
            calculartotalContador(group, "aumentar")
        } else {
            await rolesService.removePermissions([value.id], datos.id)
            const updatedPermissions = userPermissions.filter((permission: any) => (
                permission.id !== value.id
            ))
            calculartotalContador(group, "disminuir")
            setUserPermissions(updatedPermissions)
        }

    }

    const calculartotalContador = (group: string, accion: string) => {
        //console.log(group)
        switch (group) {
            case "Panel de administración":
                if (accion == "aumentar") {
                    setContadorAdministracion(contadorAdministracion + 1)
                } else {
                    setContadorAdministracion(contadorAdministracion - 1)
                }
                break;
            case "Crear convocatorias":
                if (accion == "aumentar") {
                    setContadorConvocatorias(contadorConvocatorias + 1)
                } else {
                    setContadorConvocatorias(contadorConvocatorias - 1)
                }
                break;
            case "Maestras":
                if (accion == "aumentar") {
                    setContadorMaestras(contadorMaestras + 1)

                } else {
                    setContadorMaestras(contadorMaestras - 1)
                }
                break;
            case "Postulaciones":
                if (accion == "aumentar") {
                    setContadorPostulaciones(contadorPostulaciones + 1)

                } else {
                    setContadorPostulaciones(contadorPostulaciones - 1)
                }
                break;
            case "Gestión de jurados":
                if (accion == "aumentar") {
                    setContadorJurados(contadorJurados + 1)
                } else {
                    setContadorJurados(contadorJurados - 1)
                }
                break;
        }

    }

    useEffect(() => {
        loadRoles()
        loadPermissions()
    }, [])

    return (
        <Modal
            className='ant-modal-close-x2'
            title="Configurar rol y accesos"
            visible={openModal}
            onCancel={onCancel}
            width={1200}
            maskStyle={{
                backgroundColor: "rgba(31,174,239,0.8)",
            }}
            footer={null}
        >
            <Row justify='space-between' gutter={[24, 24]}>
                <Col span={12}>
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Asignar rol
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="titulo"
                        rules={[{ required: true, message: "" }]}
                    >
                        <Select defaultValue={datos.role_id} onChange={(role: any) => updateRole(role)} placeholder="Seleccionar">
                            {
                                roles.map((role: any, i) => (
                                    <Select.Option key={i} value={role.id}>{role.name}</Select.Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Activo
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="titulo"
                        rules={[{ required: true, message: "" }]}
                    >

                        <Radio
                            type='radio'
                            value={true}
                            checked={radioValue ? true : false}
                            onChange={(e: any) => handleRadioChange(e.target.value)}
                        >
                            Si
                        </Radio>

                        <Radio
                            type='radio'
                            value={false}
                            checked={!radioValue ? true : false}
                            onChange={(e: any) => handleRadioChange(e.target.value)}
                        >
                            No
                        </Radio>
                    </Form.Item>
                </Col>
                {
                    (selectRole !== 1 && selectRole !== 3 && enableAccess) &&
                    <Col span={24}>
                        <fieldset className='fieldset' style={{
                            margin: 10,
                            padding: 10,
                            paddingBottom: 10,
                            borderRadius: 5,
                            // borderWidth: 1,
                            alignItems: 'center',
                            border: "1px solid #e5e5e5"
                        }}>
                            <legend style={{
                                position: 'absolute',
                                top: -5,
                                left: '36%',
                                width: "20%",
                                fontSize: "14px",
                                textAlign: "center",
                                backgroundColor: '#FFFFFF'
                            }}>Configurar accesos</legend>
                            <div style={{ padding: '10px' }}>
                                {permissions.map((item: any, idx: any) =>
                                    item?.group?.toUpperCase() !== "MAESTRAS" && (
                                        <Menu key={`${idx}_Menú`}
                                            mode="inline"
                                            className="menu"
                                            style={{ marginBottom: '5px', borderRadius: '10px' }}
                                        >
                                            <SubMenu style={{ borderRadius: '10px', margin: '5px' }} key={idx} title={
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="font-family-Montserrat-Bold font-size-12px">
                                                        {item.group}
                                                    </div>
                                                    {item.group == "Panel de administración" &&
                                                        <div className="font-family-Montserrat-Regular font-size-12px">
                                                            (Seleccionado: {contadorAdministracion})
                                                        </div>
                                                    }
                                                    {item.group == "Crear convocatorias" &&
                                                        <div className="font-family-Montserrat-Regular font-size-12px">
                                                            (Seleccionado: {contadorConvocatorias})
                                                        </div>
                                                    }
                                                    {item.group == "Maestras" &&
                                                        <div className="font-family-Montserrat-Regular font-size-12px">
                                                            (Seleccionado: {contadorMaestras})
                                                        </div>
                                                    }
                                                    {item.group == "Postulaciones" &&
                                                        <div className="font-family-Montserrat-Regular font-size-12px">
                                                            (Seleccionado: {contadorPostulaciones})
                                                        </div>
                                                    }
                                                    {item.group == "Gestión de jurados" &&
                                                        <div className="font-family-Montserrat-Regular font-size-12px">
                                                            (Seleccionado: {contadorJurados})
                                                        </div>
                                                    }
                                                </div>
                                            }>
                                                <div className="container__criterios__item">
                                                    {item.permissions.map((permission: any, idx: any) =>
                                                        permission?.name?.toUpperCase() !== "ASIGNAR ROLES" && permission?.name?.toUpperCase() !== "GESTIONAR MAESTRAS" && permission?.name?.toUpperCase() !== "GESTIONAR MAESTRAS JURADOS" && (
                                                            <Checkbox
                                                                className="check__categoria"
                                                                style={{ margin: '6px' }}
                                                                key={idx}
                                                                value={permission}
                                                                checked={
                                                                    userPermissions.find((perm: any) => (
                                                                        perm.id === permission.id
                                                                    )) ? true : false
                                                                }
                                                                onChange={(e) => handlePermissionCheck(e.target.value, item.group)}
                                                            >
                                                                {permission.name}
                                                            </Checkbox>
                                                        )
                                                    )}
                                                </div>
                                            </SubMenu>
                                        </Menu>
                                    )
                                )}
                            </div>

                        </fieldset>
                    </Col>
                }

            </Row>
        </Modal>
    )
}

let accesos = [
    {
        nombre_acceso: 'Crear convocatorias',
        tipos_accesos: [
            {
                tipo: "Gestor de convocatorias"
            },
            {
                tipo: "Crear convocatorias artísticas"
            },
            {
                tipo: "Crear covocatoria jurados"
            },
            {
                tipo: "Crear convocatoria BEPS"
            },
        ]
    },
    {
        nombre_acceso: 'Maestras',
        tipos_accesos: [
            {
                tipo: "Líneas Cateogorías"
            },
            {
                tipo: "Área"
            },
            {
                tipo: "Entidades"
            },
            {
                tipo: "Línea estratégica"
            },
            {
                tipo: "Actividades de cronograma"
            },
            {
                tipo: "Documentos administrativos"
            },
            {
                tipo: "Documentos técnicos"
            },
            {
                tipo: "Área-Categoría"
            },
            {
                tipo: "Criterios de evaluación"
            },
        ]
    },
    {
        nombre_acceso: 'Postulaciones',
        tipos_accesos: [
            {
                tipo: "Artístas"
            },
            {
                tipo: "Beps"
            },
            {
                tipo: "Banco de jurados"
            },
            {
                tipo: "Banco de jurados sin datos personales"
            },
            {
                tipo: "Postulación a jurados"
            },
        ]
    },
    {
        nombre_acceso: 'Gestión de Jurados',
        tipos_accesos: [
            {
                tipo: "Asignar proyectos a jurados"
            },
            {
                tipo: "Resultados de evaluación"
            },
            {
                tipo: "Inscripción extemporanea a jurado"
            },
            {
                tipo: "Registro de pagos"
            },
        ]
    },
]
